import Player from '@vimeo/player';
import YTPlayer from 'yt-player';

export default {
  init($element) {
  },
  finalize($element) {
    let ytPlayers = [];
    let vimeoPlayers = [];

    $element.find('.video-item').each(function() {
      const $videoItem = $(this);
      const videoSource = $videoItem.find('.video-player').data('source');
      const videoId = $videoItem.find('.video-player').data('video-id');
      const elId = $videoItem.find('.video-player').prop('id');

      let ytPlayer = null;
      let vimeoPlayer = null;

      if (videoSource == 'youtube') {
        // Init YouTube
        ytPlayer = new YTPlayer(`#${elId}`);
        ytPlayer.load(videoId);

        ytPlayers.push(ytPlayer);
        
        // On video ended bring back splash
        ytPlayer.on('ended', () => {
          $videoItem.find('.video-splash').show();
        });
      } else {
        // Init Vimeo
        vimeoPlayer = new Player(elId, {
          id: videoId,
        });

        vimeoPlayers.push(vimeoPlayer);
        
        // On video ended bring back splash
        vimeoPlayer.on('ended', function() {
          $videoItem.find('.video-splash').show();
        });
      }

      // On click, pause all others
      $videoItem.find('.video-splash').on('click', function() {
        // Stop all YouTube players
        if (ytPlayers.length > 0) {
          ytPlayers.forEach((player) => {
            player.stop();
          });
        }
        
        // Stop all Vimeo players
        if (vimeoPlayers.length > 0) {
          vimeoPlayers.forEach((player) => {
            player.pause();
          });
        }
        
        // Show all splashs
        $element.find('.video-item').each(function() {
          $(this).find('.video-splash').show();
        });

        // Hide current splash
        $(this).hide();

        // Play the player
        if (videoSource == 'youtube') {
          ytPlayer.play();
        } else {
          vimeoPlayer.play();
        }
      });
    });
  },
}


// WEBPACK FOOTER //
// ./scripts/partials/general/threeColumnVideo.js